import { render, staticRenderFns } from "./quotationDetails.vue?vue&type=template&id=2a7586e9&scoped=true"
import script from "./quotationDetails.vue?vue&type=script&lang=js"
export * from "./quotationDetails.vue?vue&type=script&lang=js"
import style0 from "./quotationDetails.vue?vue&type=style&index=0&id=2a7586e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7586e9",
  null
  
)

export default component.exports